// extracted by mini-css-extract-plugin
export default {"Emojify":"bbb_a bhb_g"};